import React from "react";
import emailjs from "@emailjs/browser";

export function sendEmail(form){
    emailjs.sendForm('service_v4nbfjq', 'template_8iumclo', form,'rp-6Asw0xQRmlUsex');
}